module.exports = __webpack_public_path__ + "static/closeup-65224564da1bf7f0bba428cf2c3c0f9c.webp";